module.exports = __webpack_public_path__ + "media/images/youtube-6c67823fc78c414989d58a82b5ad8896.svg";